import { ITwilioRoom } from 'types/twilio.d';
import { memberApiV2 } from '../lib/api';
import { IJoinTwilioRoomArgs } from 'types/twilio';

export function joinTwilioRoom(providerId: string, data: IJoinTwilioRoomArgs) {
  return memberApiV2.customV2<{ data: { room: ITwilioRoom } }>(
    `/management/private/calendar/order/videocall/join/${data.orderId}`,
    providerId,
    {
      method: 'POST',
    },
  );
}
